<template>
  <div class="py-10 px-10">
    <ontick-card>
      <h1 class="text-3xl font-bold text-ontick-carbon-900 dark:text-gray-300">
        Cadastro Conta XP
      </h1>
      <p class="text-gray-300 dark:text-gray-300">
        Para cadastrar sua conta é muito simples, você só precisa autorizar a
        <strong> OnTick </strong> diretamente no seu painel de investidor da XP.
        <br />
        Veja o passo a passo:
      </p>

      <div class="mt-6 py-6">
        <h2
          class="pb-2 text-xl font-bold text-ontick-carbon-900 dark:text-gray-200"
        >
          1º Passo: Acesse Sua Conta XP
        </h2>
        <p class="text-ontick-carbon-900 dark:text-gray-200">
          Acesse o site da XP através do endereço
          <a
            class="font-semibold text-ontick-blue-500"
            href="https://xpi.com.br"
            target="blank"
            >https://xpi.com.br</a
          >
          e faça o login na sua conta.
        </p>
      </div>
      <div class="py-6">
        <h2
          class="pb-2 text-xl font-bold text-ontick-carbon-900 dark:text-gray-200"
        >
          2º Passo: Acesse a seção "Autorização de Roteamento
        </h2>
        <p class="text-ontick-carbon-900 dark:text-gray-200">
          Agora que você já está logado na sua conta XP vá no menu superior e
          acesse:
        </p>
        <p class="pt-2 font-semibold italic text-ontick-blue-500">
          Minha Conta > Autorização de roteamento
        </p>
        <img
          class="py-2"
          v-img
          src="@/app/assets/imagens/cadastro_xp_ontick-01.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="py-6">
        <h2
          class="pb-2 text-xl font-bold text-ontick-carbon-900 dark:text-gray-200"
        >
          3º Passo: Ative a OnTick
        </h2>
        <p class="text-ontick-carbon-900 dark:text-gray-200">
          Agora basta você clicar na opção <strong> ATIVAR </strong> para a
          plataforma <strong>OnTick</strong>.
        </p>

        <img
          class="py-2"
          v-img
          src="@/app/assets/imagens/cadastro_xp_ontick-02.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="py-6">
        <h2
          class="pb-2 text-xl font-bold text-ontick-carbon-900 dark:text-gray-200"
        >
          4º Passo: Confirmar a solicitação na OnTick
        </h2>
        <p class="text-ontick-carbon-900 dark:text-gray-200">
          Em poucos instantes você receberá um e-mail confirmando essa
          solicitação e uma notificação na plataforma
          <strong>OnTick</strong>. Bastar clicar em <strong>CONFIRMAR</strong> e
          pronto, sua conta XP agora está disponível na nossa plataforma.
        </p>

        <!-- <img
                class="py-2"
                src="@/app/assets/imagens/cadastro_xp_ontick-02.png"
                alt=""
                srcset=""
              /> -->

        <p class="text-ontick-carbon-900 dark:text-gray-200">
          Se ainda tiver alguma dúvida entre em contato conosco através da nossa
          <a
            class="font-semibold text-ontick-blue-500"
            href="https://ajuda.ontick.com.br"
            target="blanck"
            >Central de atentidimento</a
          >. Bons negócios!
        </p>
      </div>
    </ontick-card>
  </div>
</template>

<script>
export default {
  name: "Payment",

  components: {},

  data() {
    return {
      accept_term: false,
      license_price_id: "",
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
